import { render, staticRenderFns } from "./MyData.vue?vue&type=template&id=7ef754c4"
import script from "./MyData.js?vue&type=script&lang=js&external"
export * from "./MyData.js?vue&type=script&lang=js&external"
import style0 from "./MyData.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports